import type { CategorizationRule, KeywordMapping } from '../types';

export const RULES: CategorizationRule[] = [
  {
    category: "Entertainment",
    keywords: [
      " ski ",  // With spaces to avoid matching "whiskey", "skillet", etc.
      "resort",
      "movie",
      "theater",
      "cinemark",
      "amc theatres",
      "amc ",
      "regal cinemas",
      "classic cinemas",
      "stubhub",
      "ticketmaster",
      "fandango",
      "six flags",
      "dave  busters",
      "wdw",
      "bowlero",
      "hyper kidz",
      "american girl",
      "universal orlando",
      "brookfield zoo",
      "forest preserve",
      "circus",
      "arcade",
      "bureau of parks",
      "steamgames",
      "steam",
      "xbox",
      "playstation",
      "nintendo",
    ],
  },
  {
    category: "Travel",
    keywords: [
      "airline",
      "hotel",
      "airbnb",
      "uber",
      "lyft",
      "delta air",
      "united",
      "american air",
      "southwest air",
      "jetblue",
      "spirit air",
      "frontier air",
      "marriott",
      "hilton",
      "hyatt",
      "ihg hotels",
      "best western",
      "holiday inn",
      "vrbo",
      "hertz",
      "enterprise rent",
      "budget rent",
      "mta ",
      "spothero",
    ],
  },
];

export const DISPLAY_NAMES: KeywordMapping[] = [
  { keyword: "amc theatres", displayName: "AMC Theatres" },
  { keyword: "amc ", displayName: "AMC" },
  { keyword: "regal cinemas", displayName: "Regal Cinemas" },
  { keyword: "ticketmaster", displayName: "Ticketmaster" },
  { keyword: "stubhub", displayName: "StubHub" },
  { keyword: "six flags", displayName: "Six Flags" },
  { keyword: "steamgames", displayName: "Steam" },
  { keyword: "steam", displayName: "Steam" },
  { keyword: "xbox", displayName: "Xbox" },
  { keyword: "playstation", displayName: "PlayStation" },
  { keyword: "nintendo", displayName: "Nintendo" },
  { keyword: "airbnb", displayName: "Airbnb" },
  { keyword: "uber", displayName: "Uber" },
  { keyword: "lyft", displayName: "Lyft" },
];
